import styled from 'styled-components/macro'

export const DraftDotsMenuContainer = styled.div`
  transform: translate(1.5rem, -1.5rem);
`
